"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _reactSelect = require("react-select");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pacomo = require("utils/pacomo");

var _forms = require("metadata/forms");

var _forms2 = require("utils/forms");

var _components2 = require("components");

var _selectors = require("selectors");

var _bookingCompanies = require("../../utils/bookingCompanies");

var _travelStyles = require("../../utils/mappings/travel-styles");

var _utils = require("../../utils/mappings/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaxSelect = function PaxSelect(_ref) {
    var id = _ref.id,
        intl = _ref.intl,
        placeholder = _ref.placeholder,
        requirement = _ref.requirement,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        helpText = _ref.helpText,
        customersById = _ref.customersById,
        input = _ref.input,
        bookingCompanyId = _ref.bookingCompanyId,
        bookingMeta = _ref.bookingMeta,
        bookingServices = _ref.bookingServices,
        excludedCustomers = _ref.excludedCustomers;

    function formatValue(customersById, value, requirement) {
        var reqCustomer = requirement.customer;
        var reqReason = (0, _forms2.getReqField)(requirement, "reason");
        var values = _lodash2.default.uniqBy(value, "id");
        var roommates = [];

        if (customersById && values) {
            values.forEach(function (pax) {
                var foundCustomer = customersById[pax.id];
                if (foundCustomer && pax.id != reqCustomer) {
                    roommates.push({
                        value: pax.id,
                        label: foundCustomer.name.legal_first_name + " " + foundCustomer.name.legal_last_name
                    });
                } else if (!foundCustomer && pax.id != reqCustomer) {
                    roommates.push({
                        value: pax.id,
                        label: "Same-Gender Solo Traveller"
                    });
                } else if (foundCustomer && pax.id == reqCustomer && reqReason && reqReason.value && reqReason.value == "MY_OWN_ROOM") {
                    roommates.push({
                        value: pax.id,
                        label: "No Roommate (My Own Room)"
                    });
                } else if (foundCustomer && pax.id == reqCustomer && reqReason && reqReason.value &&
                // We might still to double if we
                // need to remove `Same-Gender Solo Traveller`
                // For my MY_OWN_ROOM but for now I removed this
                reqReason.value != "MY_OWN_ROOM" && values.length == 1 && ![4, 3].includes(Number(bookingCompanyId))) {
                    roommates.push({
                        value: pax.id,
                        label: "Same-Gender Solo Traveller"
                    });
                }
            });

            return roommates;
        } else {
            return [];
        }
    }

    function formatOptions(customersById, reqCustomer, bookingCompanyId) {
        var list = [];
        var bookingMetaCustomerIds = new _set2.default((bookingMeta && bookingMeta.customers || []).map(function (item) {
            return item && item.customer && item.customer.id;
        }).filter(Boolean).map(String));

        if (customersById) {
            (0, _keys2.default)(customersById).filter(function (key) {
                return key != reqCustomer;
            }).forEach(function (customerId) {
                var pax = customersById[customerId];

                var isPaxInSameBooking = bookingMetaCustomerIds.has(String(customerId));
                var hasConfirmedSingleSupplement = (0, _utils.hasConfirmedSingleSupplementForPax)(bookingServices, customerId);
                var shouldSkipPax = isPaxInSameBooking && hasConfirmedSingleSupplement;

                if (pax && !shouldSkipPax) {
                    list.push({
                        value: customerId,
                        label: pax.name.legal_first_name + " " + pax.name.legal_last_name
                    });
                }
            });

            var GT_COMPANY_IDS = [4, 3];
            var _id = Number(bookingCompanyId);
            // I know this is not the cleanest way but it works
            if (!(0, _travelStyles.isNatGeoSignature)(bookingMeta) && !GT_COMPANY_IDS.includes(_id)) {
                list.push({
                    value: 0,
                    label: "Same-Gender Solo Traveller"
                });
            }
            return list.filter(function (pax) {
                return !excludedCustomers.includes(pax.value);
            });
        }

        return [];
    }

    function _onChange(option, input, reqCustomer) {
        if (!option.length) {
            return input.onChange([]);
        }
        // We support rooming with a _single_ roommate [for now]
        // so we only care about the last item selected by the user
        var lastItem = option[option.length - 1];
        if (lastItem) {
            return input.onChange([{ value: reqCustomer }, lastItem].map(function (i) {
                return {
                    id: i.value
                };
            }));
        } else {
            return input.onChange([]);
        }
    }

    var name = input.name,
        value = input.value;

    var inputProps = {
        id: id,
        name: name
    };

    var selectProps = (0, _extends3.default)({}, inputProps, {
        value: formatValue(customersById, value, requirement),
        options: formatOptions(customersById, requirement.customer, bookingCompanyId),
        onChange: function onChange(option) {
            return _onChange(option, input, requirement.customer);
        },
        placeholder: placeholder || intl.formatMessage(_forms.formPlaceholders.searchPrompt),
        searchPrompText: intl.formatMessage(_forms.formPlaceholders.searchPrompt),
        searchingText: intl.formatMessage(_forms.formPlaceholders.searching),
        noResultsText: intl.formatMessage(_forms.formPlaceholders.noResultsText)
    });

    var isDisabled = function isDisabled() {
        var hasOneCompanionIncludingSelf = (0, _entries2.default)(customersById).length < 3;

        return (0, _bookingCompanies.isGTBookingCompany)(bookingCompanyId) && hasOneCompanionIncludingSelf;
    };

    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components2.FieldHelpErrorText, {
            touched: touched,
            error: error,
            helpText: helpText
        }),
        _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, selectProps, { multi: true, disabled: isDisabled() }))
    );
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        customersById: (0, _selectors.getAllCustomers)(state),
        bookingMeta: state.bookingMeta,
        bookingServices: state.bookingServices
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)((0, _pacomo.pacomoTransformer)(PaxSelect)));

// Pass in the Props

PaxSelect.propTypes = {
    bookingCompanyId: _propTypes2.default.number.isRequired,
    bookingMeta: _propTypes2.default.object.isRequired,
    excludedCustomers: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))
};

PaxSelect.defaultProps = {
    excludedCustomers: []
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/PaxSelect.js
// module id = 634
// module chunks = 0